// the semi-colon before function invocation is a safety net against concatenated
// scripts and/or other plugins which may not be closed properly.
;( function( $, window, document, undefined ) {

    "use strict";

    // undefined is used here as the undefined global variable in ECMAScript 3 is
    // mutable (ie. it can be changed by someone else). undefined isn't really being
    // passed in so we can ensure the value of it is truly undefined. In ES5, undefined
    // can no longer be modified.

    // window and document are passed through as local variables rather than global
    // as this (slightly) quickens the resolution process and can be more efficiently
    // minified (especially when both are regularly referenced in your plugin).

    // Create the defaults once
    var hasBeenCreated = false;
    var pluginName = 'slidePanel';
    var plugin = false;
    var panel_html = '';
    var open_panel = false;
    var formControlErrorClass = 'form-control--error'

    var defaults = {
        loading_icon_selector: '.loading',
        panel_class: 'bg-silver',
        default_panel_class: 'info-panel js-info-panel',
        content_url: '#',
        success_redirect_url: '',
        show_notify_shared_users_button: false,
        post_url: function(){
            return this.content_url;
        },
        additional_data: '',
        form_enctype: 'application/x-www-form-urlencoded',
        onLoad: function(plugin) {
            plugin.handleOnChange();
        },

        beforePost: function() {
            return true;
        },

        onPost: function() {

        },

        onPostError: function() {

        },

        onClose: function() {

        }
    };

    var Selector = {
        close_btn: '.js-close-info-panel-btn',
        content: '.js-info-panel-content',
        submit_btn: '.js-info-panel-submit-btn',
        submit_and_notify_btn: '.js-info-panel-submit-and-notify-btn',
        submit_container: '.js-info-panel-submit-container',
        panel_form: '.js-info-panel-form',
        form_control: '.form-control',
        form_error: '.form-error',
    };

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        // jQuery has an extend method which merges the contents of two or
        // more objects, storing the result in the first object. The first object
        // is generally empty as we don't want to alter the default options for
        // future instances of the plugin

        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init(defaults, options, function() {
            hasBeenCreated = true;
        });
    }

    // Avoid Plugin.prototype conflicts
    $.extend( Plugin.prototype, {
        init: function(defaults, options, callback) {
            plugin = this;
            // Place initialization logic here
            // You already have access to the DOM element and
            // the options via the instance, e.g. this.element
            // and this.settings
            // you can add more functions like the one below and
            // call them like the example below
            //this.yourOtherFunction( "jQuery Boilerplate" );

            plugin.resetPanel();

            plugin.removePanelClass(defaults, options);
            plugin.setPanelClass(defaults, options);

            $(plugin.settings.loading_icon_selector).show();
            plugin.registerEvents($(plugin));

            if (typeof callback === 'function') {
                callback();
            }
        },

        open: function() {
            $(plugin.element).addClass('active');
        },

        close: function() {
            $(plugin.element).off().removeClass('active');
        },

        setPanelClass: function(defaults, options) {
            $(plugin.element).addClass(plugin.settings.panel_class);
        },

        removePanelClass: function(defaults, options) {
            $(plugin.element).attr('class', plugin.settings.default_panel_class);
        },

        registerEvents: function() {
            if (hasBeenCreated === false) {
                $(Selector.close_btn).on('click', function() {
                    plugin.resetPanel();
                    plugin.settings.onClose();
                    open_panel = false;
                    plugin.destroy();
                });

                $(document).focus().keyup(function(e) {
                    var code = e.which;
                    if(code == 27 && $(plugin.element).hasClass('active')) {
                        $(Selector.close_btn).click();
                    }
                });
            }
        },

        resetPanel: function() {

            if(typeof tinymce !== 'undefined'){
                tinymce.remove('.js-info-panel textarea');
            }
            plugin.close();

            $(Selector.content).html('');

            if ($(Selector.submit_btn).length) {
                $(Selector.submit_btn).remove();
            }



            if ($(Selector.submit_and_notify_btn).length) {
                $(Selector.submit_and_notify_btn).remove();
            }
        },

        destroy: function() {
            $(plugin.element).removeData();
        },

        _setupInfo: function(html, callback) {
            plugin.open();
            $(Selector.content).html(html);
            plugin.refreshFormFieldPlugins();
            $(plugin.settings.loading_icon_selector).hide();

            if (typeof callback === 'function') {
                callback();
            }
        },

        info: function() {
            if(plugin.settings.content_url.charAt(0) == '#' && plugin.settings.content_url.length > 1){
                plugin._setupInfo($(plugin.settings.content_url).html(), function() {
                    plugin.settings.onLoad(plugin);
                });
            }else{
                open_panel = plugin.settings.content_url;

                $.get(plugin.settings.content_url, function(panel_html){
                    plugin._setupInfo(panel_html, function() {
                        plugin.settings.onLoad(plugin);
                    });
                });
            }

            // TODO: not sure what the point of this is?
            plugin.destroy();
        },

        _formEvents: function($elem, self) {
            $(Selector.submit_btn, $elem).on('click', function(e) {
                e.preventDefault();
                plugin.submitForm();
            });

            $(Selector.submit_and_notify_btn).on('click', function() {
                $('#notify-shared-user-modal').modal('show');
            });

            $($elem).focus().keyup(function(e) {
                var tagName = e.target.tagName;
                var code = e.which;
                if(code == 13 && tagName != 'TEXTAREA') {
                    $(Selector.submit_btn).trigger('click');
                }
            });
        },

        _buildForm: function($elem) {
            $(Selector.submit_container, $elem).prepend(
                '<button class="btn btn-sm btn-primary js-info-panel-submit-btn" type="submit">Submit</button> '
            );

            $(Selector.content, $elem).append($('<form/>', {
                class: 'js-info-panel-form',
            }).attr('autocomplete', 'off').attr('validate', 'off').attr('enctype', plugin.settings.form_enctype));

            $(Selector.panel_form, $elem).append($('<div/>', {
                class: 'js-info-panel-fields'
            }));
            if ($('#js-leads-table').length) {
                if (typeof NotifySharedUsersModal === 'object') {
                    var enableButton = NotifySharedUsersModal.anySelectedUsersAreShared();
                    var extraButtonClass = enableButton ? '' : ' disabled';

                    var submitAndNotifyButton = '<button class="btn btn-sm btn-warning js-info-panel-submit-and-notify-btn' + extraButtonClass + '"><i class="fa fa-envelope-o"></i> <span class="text">Notify Shared Users</span></button> ';
                    $(Selector.submit_container).append(submitAndNotifyButton);

                    NotifySharedUsersModal.refresh();
                }
            }
        },
        form: function() {
            var $elem = $(plugin.element);

            plugin._buildForm($elem);
            plugin._formEvents($elem, this);

            $.get(plugin.settings.content_url, function(panel_html) {
                plugin.open();
                $('.js-info-panel-fields').html(panel_html);
                $('.js-info-panel-fields input:visible:first').focus();
                plugin.refreshFormFieldPlugins();
                $(plugin.settings.loading_icon_selector).hide();
                plugin.settings.onLoad(plugin);
            });

            plugin.destroy();
        },

        refreshFormFieldPlugins: function() {
            var $elem = $(plugin.element);

            $('.js-info-panel-content .selectpicker', $elem).selectpicker('render');
            $('.js-info-panel-content .date-picker', $elem).datepicker().on('changeDate', function(e) {
                $(this).datepicker('hide');
            });

            $('.js-info-panel-content .input-daterange-month input').datepicker({
                keepEmptyValues: true,
                format: 'mm/dd',
                startView: 'month',
                minViewMode: 'days',
                maxViewMode:'months'
            });

            $('.js-info-panel-content .input-daterange input').datepicker({
                keepEmptyValues: true
            });

            $('.js-info-panel-content .time-picker', $elem).timepicker();

            $(document).trigger('filterPanel:loaded');
        },

        submitForm: function() {
            $(plugin.settings.loading_icon_selector).show();

            $(Selector.submit_btn).attr('disabled', true);
            $(plugin.settings.loading_icon_selector).show();

            if(plugin.settings.beforePost() && plugin.validateForm()){
                plugin.postForm(
                    plugin.settings.post_url(),
                    plugin.settings.onPost,
                    plugin.settings.onPostError
                );

                if(open_panel){
                    plugin.settings.content_url = open_panel;
                    open_panel = false;
                    plugin.info();
                }
            }else{
                $(Selector.submit_btn).attr('disabled', false);
            }
        },

        postForm: function(post_url, successCallback, errorCallback) {
            var errorHandler = function(xhr, txt, errorThrown) {
                if (xhr.responseJSON.msg || xhr.responseJSON.error) {
                    FlashMessage.message({
                        type: 'error',
                        message: xhr.responseJSON.msg ? xhr.responseJSON.msg: xhr.responseJSON.error,
                        showClose: true
                    });
                }

                $(Selector.submit_btn).removeAttr('disabled');
                $(plugin.settings.loading_icon_selector).hide();
                errorCallback(xhr.responseJSON);
            };

            var successHandler = function (data, txt, xhr) {
                var displayMessage = 'Success';
                var messageType = 'success';

                if (typeof data.status !== 'undefined' && data.status == 0) {
                    displayMessage = 'Error';
                    messageType = 'error';
                }

                if (typeof data.message === 'string' && data.message.length > 0) {
                    displayMessage += ': ' + data.message;
                }

                FlashMessage.message({
                    type: messageType,
                    message: displayMessage
                });

                plugin.close();
                $(plugin.settings.loading_icon_selector).hide();
                successCallback(data);
                if(plugin.settings.success_redirect_url.length > 0){
                    setTimeout(function(){
                        location.replace(plugin.settings.success_redirect_url);
                    }, 500);
                }
                plugin.destroy();
            };

            if(typeof tinymce !== 'undefined'){
                tinymce.triggerSave();
            }

            if(plugin.settings.form_enctype == 'multipart/form-data'){
                $.ajax({
                    url: post_url,
                    data: new FormData($('.js-info-panel-form')[0]),
                    type: 'POST',
                    global: false,
                    processData: false,
                    contentType: false,
                    success: successHandler,
                    error: errorHandler
                });
            } else {
                $.ajax({
                    url: post_url,
                    data: $('.js-info-panel-form').serialize()+plugin.settings.additional_data,
                    type: 'POST',
                    global: false,
                    success: successHandler,
                    error: errorHandler
                });
            }
        },

        validateForm: function() {
            let isValid = true

            $(plugin.element).find(Selector.form_control).each(function() {
                if ($(this).prop('required')) {
                    if (!$(this).val().trim()) {
                        $(this).addClass(formControlErrorClass)
                        $(this).siblings(Selector.form_error).show()
                        isValid = false
                    }
                }
            })

            return isValid
        },

        handleOnChange: function() {
            $(plugin.element).find(Selector.form_control).on('change', function() {
                if ($(this).prop('required')) {
                    if ($(this).val().trim()) {
                        $(this).removeClass(formControlErrorClass)
                        $(this).siblings(Selector.form_error).hide()
                    } else {
                        $(this).addClass(formControlErrorClass)
                        $(this).siblings(Selector.form_error).show()
                    }
                }
            })
        }
    } );

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[ pluginName ] = function( options ) {
        this.each( function() {
            if ( !$.data( this, "plugin_" + pluginName ) ) {
                $.data( this, "plugin_" +
                    pluginName, new Plugin( this, options ) );
            }
        } );
        return this;

    };

} )( jQuery, window, document );
